/**
 * architectureModel.js — what the PUBLIC view of the Architecture Explorer may say.
 * ===========================================================================
 *
 * ⛔ THE STRUCTURE IS NO LONGER HERE. Node trees, kind definitions and the operating sequences moved
 * to server/content/architectureStructure.js on 2026-09-12 and are served by
 * GET /api/architecture/structure behind authenticateToken.
 *
 * Anything in THIS file ships to every visitor in the JS bundle and is readable in devtools, so it
 * must be safe to publish. Keep it to general statements: no node names, no relationship names, no
 * step-by-step pipeline, no key templates.
 *
 * ⚠️ DO NOT MOVE STRUCTURE BACK HERE, however convenient.
 * server/tests/adminContentNotInClientBundle.test.js fails if it appears under client/src.
 */

/**
 * The terse public blurb. This is the WHOLE public view — a reader who is not signed in sees this
 * and nothing else.
 */
export const publicSummary = {
  blurb: 'AuthoratorAI turns a finished manuscript into a narrated audiobook. It reads the '
    + 'typeset book, works out who speaks each line, gives every character a voice, and renders '
    + 'and assembles the result chapter by chapter.',
  points: [
    'Written work in, narrated audio out.',
    'Characters keep a consistent voice across every book in a series.',
    'Voices can be designed from a description, or built from a real recorded performance.',
    'Sign in to explore the structure behind this, and to see it against your own series.'
  ]
};

export const s3Overview = {
  blurb: 'Every stored file — source PDFs, recorded takes, cloned-voice artifacts, rendered lines '
    + 'and finished chapters — is kept in our secure repository.',
  points: [
    'A named registry entry manages locations for each unique user.'
  ]
};

/**
 * The technical framing, DISPLAYED only when the admin payload arrived.
 *
 * ⚠️ THE NAME PROMISES MORE THAN IT DELIVERS, and that is worth stating plainly because the same
 * confusion has already cost two commits on this component. This constant is in the CLIENT BUNDLE:
 * every visitor downloads it and can read it in devtools. The `adminDetail.storage` condition
 * decides whether it is DRAWN, not whether it is DELIVERED.
 *
 * ⭐ That is acceptable ONLY because the content is harmless — it describes an approach and names
 * no bucket, prefix or key template. ⛔ Do not add anything here that needs protecting. Anything
 * that must not reach a public reader belongs in server/content/architectureAdminNotes.js behind
 * requireAdmin, like the paths themselves.
 */

export const s3OverviewAdmin = {
  blurb: 'Every stored file — source PDFs, recorded takes, cloned-voice artifacts, rendered lines '
    + 'and finished chapters — is addressed through a central Path Registry rather than by paths '
    + 'written into the code. One named entry owns each kind of file, so the place a thing belongs '
    + 'is defined once and every reader and writer agrees.',
  points: [
    'A named registry entry per file type, held in the database rather than in code.',
    'Uploads and deletes resolve the same entry by NAME, so they cannot disagree about where a file lives.',
    'Storage layout detail is available to signed-in administrators.'
  ]
};
